import { type HierarchicalMenu, type QueryParams } from "./typed";

interface HierarchicalMenuMapperProps {
  hierarchicalMenuAttributes: string[];
}

const hierarchicalMenuMapper = (props: HierarchicalMenuMapperProps) => {
  const {
    hierarchicalMenuAttributes,
  } = props;

  // Somehow on router level, algolia only use first level to store all hierarchical data
  const hierarchicalKey = hierarchicalMenuAttributes[0];

  return {
    createURL: (hierarchicalMenu: HierarchicalMenu): QueryParams => {
      const queryParams: QueryParams = {};

      if (!hierarchicalMenu) {
        return queryParams;
      }

      const hierarchicalValue = hierarchicalMenu[hierarchicalKey];

      queryParams.c = `${hierarchicalValue.join(".")}`;

      return queryParams;
    },
    parseURL: (queryParams: QueryParams | undefined): HierarchicalMenu => {
      if (!queryParams || !queryParams.c || typeof queryParams.c !== "string") {
        return undefined;
      }

      const hierarchicalValue = queryParams.c.split(".");

      const hierarchicalMenu: HierarchicalMenu = {};
      hierarchicalMenu[hierarchicalKey] = hierarchicalValue;

      return hierarchicalMenu;
    },
  };
};

export {
  hierarchicalMenuMapper,
};
